<template>
  <div class="swiper mySwiper">
    <div class="swiper-wrapper" :class="{'swiper-wrapper-mobile': isMobile, 'swiper-no-swiping': !isMobile}"
      ref="mySwiper">
      <div v-for="(item, i) in data" :key="i" class="swiper-slide" :class="{active: i == index}"
        @click="changeConsultTab(i,item.id)">
        <span class="hot" v-if="item.isHot"></span>
        {{ item.name }}
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from 'swiper';
export default {
  name: 'personal_center',

  data() {
    return {
      swiper_list: [],
    };
  },
  props: {
    data: {
      type: Array,
      default: function () {
        return [];
      },
    },
    index: {
      type: String | Number,
      default: '',
    },
    isMobile: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    mySwiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  watch: {
    data: {
      deep: true,
      handler(newValue, oldValue) {
        this.$nextTick(() => {
          window.swiper = new Swiper('.mySwiper', {
            width: 400,
            slidesPerView: 'auto',
            spaceBetween: 12,
            freeMode: this.isMobile,
            noSwiping: true,
          });
          if (!this.isMobile) {
            this.$nextTick(() => {
              let dom = document.querySelector('.pc.dataImage');
              let group = document.querySelector('.group-wrapper');
              dom.style.paddingTop = 68 + group.clientHeight + 'px';
            });
          }else {
            const {swiper} =  window
            swiper.slideTo(this.index-1)
          }
        });
      },
      // immediate: true,
    },
  },
  mounted() {},
  methods: {
    changeConsultTab(index,id) {
      this.$Bus.$emit('changeGroup', index,id);
    },
  },
};
</script>
<style lang="less" scoped>
.swiper {
  overflow: hidden;
  height: 100% !important;
  .swiper-wrapper {
    display: flex;
    flex-wrap: wrap;
    .swiper-slide {
      width: auto !important;
      padding: 4px 16px 4px 16px;
      background: rgba(117, 118, 153, 0.1);
      border-radius: 16px;
      height: 28px;
      color: #474762;
      display: flex;
      align-items: center;
      flex-grow: 0;
      flex-shrink: 0;
      cursor: pointer;
      margin-right: 12px;
      margin-bottom: 12px;
      line-height: 28px;
      &:hover {
        background: rgba(117, 118, 153, 0.14);
      }
      .hot {
        width: 20px;
        height: 20px;
        background: url('~@/assets/images/hot.svg') 20px 20px;
        margin-right: 2px;
        margin-left: -4px;
      }
    }
    .active {
      background: #1b63d9 !important;
      color: #fff;
      font-weight: 600;
      .hot {
        background: url('~@/assets/images/hotWhite.svg') 20px 20px;
      }
    }
  }
  .swiper-wrapper-mobile {
    flex-wrap: nowrap;
    .swiper-slide {
      padding: 4px 12px 4px 12px;
      background: rgba(0, 0, 0, 0.04);
      border-radius: 4px;
      margin-right: 8px;
      .hot {
        margin-left: -4px;
      }
      &:hover {
        background: rgba(0, 0, 0, 0.04);
      }
    }
    .active {
      background: linear-gradient(128deg, #F28B43 7%, #E05220 100%) !important;
      color: #fff;
    }
  }
}
</style>
